exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inputText---bkJoK, .disabled---jEjgj {\n  height: 38px;\n  width: 100%;\n  padding: 0 12px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 38px;\n  outline: none; }\n\n.disabled---jEjgj {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---bkJoK",
	"disabled": "disabled---jEjgj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/teacher-details/text-input.scss
// module id = 1204
// module chunks = 3